module.exports = __webpack_public_path__ + "img/photo_boy.316effc3.png";